import { observer } from 'mobx-react-lite'
import { EnumSpinnerLoaderPosition, FullPageWrapper, SpinnerLoader } from 'shared/ui'
import { ContactsDetails } from 'widgets/ContactsDetails'
import { ClickToTextStatisticsTableLeads } from 'pages/clickToText/pages/viewClickToText/ui/сlickToTextStatisticsTableLeads/ClickToTextStatisticsTableLeads'
import { useClickToTextDetailsContext } from 'pages/clickToText/pages/viewClickToText/context'
import { ClickToTextStatisticsTableClicks } from 'pages/clickToText/pages/viewClickToText/ui/сlickToTextStatisticsTableClicks/ClickToTextStatisticsTableClicks'
import {
  ClickToTextDetailsHeader,
  ClickToTextStatisticsFilter,
  ClickToTextStatisticsSearch,
} from './Details'

export const ClickToTextDetails = observer(() => {
  const { isLoading, isClicksFilter, isLeadsFilter, contactsDetailsStore } =
    useClickToTextDetailsContext()

  if (isLoading) {
    return (
      <SpinnerLoader
        ariaLabel={'ClickToTextDetails'}
        position={EnumSpinnerLoaderPosition.Absolute}
      />
    )
  }

  return (
    <FullPageWrapper>
      <ClickToTextDetailsHeader />
      <ClickToTextStatisticsFilter />
      {isLeadsFilter && <ClickToTextStatisticsSearch />}
      {isLeadsFilter && <ClickToTextStatisticsTableLeads />}
      {isLeadsFilter && contactsDetailsStore && <ContactsDetails store={contactsDetailsStore} />}
      {isClicksFilter && <ClickToTextStatisticsTableClicks />}
    </FullPageWrapper>
  )
})
